// NOTE other possibly relevant libraries:
//
// http://drawsvg.org/drawsvg.html#showcase:text-editor
//   SVG-Edit
//
// https://www.npmjs.com/package/jsyg-texteditor
//
// https://www.npmjs.com/package/svg-text-wrap:
//   Give a string, a desired width, and some svg style attributes, get back an array
//
// https://www.npmjs.com/package/svg-text-size:
//   Get a {width, height} given a text string (or array) and svg attributes
//   browser-only
//
// https://github.com/reactjs/react-art/blob/master/src/ReactART.js#L539
// https://github.com/ariutta/cross-platform-text/blob/master/lib/svg.js
// https://github.com/d3plus/d3plus-text: depends on d3.js
// https://www.npmjs.com/package/svg-text: browser-only
// https://www.npmjs.com/package/typesettable: browser-only
// https://www.npmjs.com/package/react-text-on-svg
// http://svgjs.com/elements/#svg-text: no vertical or horizontal alignment
//
// https://www.npmjs.com/package/node-calculate-size:
//   Node API and CLI for calculating text sizes using phantomJS.
//
// https://www.npmjs.com/package/word-wrap
// https://www.npmjs.com/package/word-wrappr
// For more details, see
// http://www.w3.org/TR/SVG11/text.html#TextAnchorProperty
// start | middle | end | inherit
// and
// http://www.w3.org/TR/CSS2/text.html#alignment-prop
// left | right | center | justify | inherit
/* NOTE: this will display text as if the following CSS were in effect:

.text {
  box-sizing: border-box;
  display: table-cell;
  margin: 0px;
}

//*/
const direction = require("direction");
import * as React from "react";
// TODO use TS types updated for version 16. But I also have some changes
// I made for SVG attributes that need to get merged.
const Fragment = React["Fragment"];
const LTR_CENTRIC_TEXT_ALIGNS = ["left", "right"];
const shiftXCalculatorsByTextAlign = {
    left: function (textDirection, padding, width) {
        return padding;
    },
    start: function (textDirection, padding, width) {
        if (textDirection === "rtl") {
            return width - padding;
        }
        else {
            return padding;
        }
    },
    center: function (textDirection, padding, width) {
        return width / 2;
    },
    end: function (textDirection, padding, width) {
        if (textDirection === "rtl") {
            return padding;
        }
        else {
            return width - padding;
        }
    },
    right: function (textDirection, padding, width) {
        return width - padding;
    }
};
const shiftYCalculatorsByContainerVerticalAlign = {
    top: (totalTextHeight, lineHeightPx, padding, height) => padding + totalTextHeight / 2 + lineHeightPx / 2,
    middle: (totalTextHeight, lineHeightPx, padding, height) => height / 2,
    bottom: (totalTextHeight, lineHeightPx, padding, height) => height - padding - totalTextHeight / 2 - lineHeightPx / 2
};
const textAnchorCalculatorsByTextAlign = {
    start: textDirection => "start",
    end: textDirection => "end",
    left: function (textDirection) {
        return "start";
        /*
        if (textDirection === "rtl") {
          return "end";
        } else {
          return "start";
        }
            //*/
    },
    center: function (textDirection) {
        return "middle";
    },
    right: function (textDirection) {
        return "end";
        /*
        if (textDirection === "rtl") {
          return "start";
        } else {
          return "end";
        }
            //*/
    }
};
export class Text extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { props } = this;
        const { color, height, id, className, padding = 0, width, verticalAlign, fontFamily, fontSize, fontStyle = "normal", fontWeight = "normal", lineHeight: lineHeightUnitless, overflow = "visible", rotation = 0, stroke = "none", strokeWidth = 0, textAlign = "start", textContent = "", textOverflow = "clip", whiteSpace = "normal" } = props;
        const fill = props.fill || props.color || "currentColor";
        // TODO the CSS property text-shadow is related to
        // the SVG stroke and stroke-width properties:
        // text-shadow https://developer.mozilla.org/en-US/docs/Web/CSS/text-shadow
        //
        // These ones are also related but not part of a standard ATM:
        // -webkit-text-stroke
        // -webkit-text-fill
        // text-outline
        // TODO text-overflow:
        // ellipsis, clip, "…" (string)
        // https://developer.mozilla.org/en-US/docs/Web/CSS/text-overflow
        //
        // SVG has an overflow property but we need to establish a new viewport to
        // make it work for text or tspan.
        // set a clip path to match clip?
        //
        // Also, there are the textLength and lengthAdjust properties, but they
        // don't seem directly related to the text-overflow property
        // https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/textLength
        // https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/lengthAdjust
        /* TODO does this handle test cases like these?
            // mixed rtl and ltr content:
        const textContent = "exclamation point -- באמת! -- on the right.";
        const textContent = "בצד ימין  -- really! -- סימן קריאה.";
        const textContent = "exclamation point -- באמת!‏ -- on the left.";
        const textContent = "בצד שמאל  -- really‎! -- סימן קריאה.";
          // multiline rtl:
        const textContent = "אחר \nצהריים טובים";
            // Notice also that PathVisio only produces left, center, right, so the
            // GPML tests don't include start and end!
        const textAlign = "start";
        const textAlign = "end";
            */
        const ltrCentric = LTR_CENTRIC_TEXT_ALIGNS.indexOf(textAlign) > -1;
        const lineHeightPx = lineHeightUnitless * fontSize;
        // TODO what about writing-mode and Chinese/Japanese scripts?
        // https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/writing-mode
        // https://developer.mozilla.org/en-US/docs/Web/CSS/writing-mode
        const textDirection = direction(textContent);
        const textAnchor = textAnchorCalculatorsByTextAlign[textAlign](textDirection);
        let lines;
        const supportedOverflowValues = ["visible", "hidden"];
        if (supportedOverflowValues.indexOf(overflow) === -1) {
            throw new Error(`Only ${supportedOverflowValues.join(", ")} currently supported for overflow. Pull requests welcome!`);
        }
        const supportedTextOverflowValues = ["clip"];
        if (supportedTextOverflowValues.indexOf(textOverflow) === -1) {
            throw new Error(`Only ${supportedTextOverflowValues.join(", ")} currently supported for textOverflow. Pull requests welcome!`);
        }
        if (whiteSpace === "pre") {
            // These are the most common ways to specify linebreaks:
            const lineBreakRegex = /\r\n|\r|\n|&#xA;|<br>|<br\/>/g;
            lines = textContent.split(lineBreakRegex);
            if (direction(textContent) === "rtl") {
                // U+200E <200e> is https://en.wikipedia.org/wiki/Left-to-right_mark
                // U+200F ‏ is https://en.wikipedia.org/wiki/Right-to-left_mark
                // It seems necessary to prefix the line with U+200E in order to make
                // multiple lines of RTL text split correctly in Chrome, but FF seems
                // to display correctly both with and without.
                lines = lines.map(line => "‎" + line);
                // TODO do we need to add U+200F anywhere to correct for adding the
                // U+200E prefix? Maybe something like this?
                //lines = lines.map(line => "‎" + line.split('').map(character => character + '‏').join(''));
            }
            //} else if (whiteSpace === "normal") {
        }
        else {
            throw new Error("Only pre currently supported for whiteSpace. Pull requests welcome!");
        }
        const lineCount = lines.length;
        const shiftX = shiftXCalculatorsByTextAlign[textAlign](textDirection, padding, width);
        const totalTextHeight = (lineCount - 1) * lineHeightPx;
        const shiftY = shiftYCalculatorsByContainerVerticalAlign[verticalAlign](totalTextHeight, lineHeightPx, padding, height);
        const transforms = [];
        transforms.push(`translate(${shiftX},${shiftY})`);
        if (rotation) {
            transforms.push(`rotate(${rotation},
					${width / 2 - shiftX},
					${height / 2 - shiftY})`);
        }
        const clipPathId = `${id}-text-clipPath`;
        /*
              x={-1 * shiftX}
        y={-1 * height / 2}
                  y={-1 * shiftY + lineHeightPx / 2}
            //*/
        // NOTE: in Chrome, direction and fontSize need to be applied to the
        // tspan elements, not the parent text element. Otherwise, they don't
        // take effect.
        //
        // We need to apply a diagram-wide style to the SVG to make text and/or tspan elements inherit their container's styling:
        // .textContent * {
        //   fill: inherit;
        //   font-size: inherit;
        //   ...
        // }
        return (React.createElement(Fragment, null,
            overflow === "hidden" ? (React.createElement("defs", null,
                React.createElement("clipPath", { id: clipPathId },
                    React.createElement("rect", { x: -1 * shiftX, y: -1 * shiftY, width: width, height: height })))) : null,
            React.createElement("text", { id: id, className: "Text" + (!!className ? " " + className : ""), clipPath: overflow === "hidden" ? `url(#${clipPathId})` : null, direction: ltrCentric ? "ltr" : textDirection, dominantBaseline: "central", fill: fill, fontFamily: fontFamily, fontSize: `${fontSize}px`, fontStyle: fontStyle, fontWeight: fontWeight, overflow: overflow, stroke: stroke, strokeWidth: strokeWidth, textAnchor: textAnchor, transform: transforms.join(" ") }, lines.map(function (line, i) {
                // These two are equivalent:
                //y={(i - (lineCount - 1) / 2) * lineHeightPx}
                // and
                //					dy={
                //						i === 0 ? -1 * (lineCount - 1) * lineHeightPx / 2 : lineHeightPx
                //					}
                return (React.createElement("tspan", { key: `text-line-${i}-${line}`, x: "0", y: (i - (lineCount - 1) / 2) * lineHeightPx }, line));
            }))));
    }
}
//    const dx = lines
//      .reduce(function(acc, line) {
//        const characterCount = line.length;
//        for (let i = 0; i < characterCount; i++) {
//          acc.push(0);
//        }
//        acc.push(-1 * (fontSize / lineHeightUnitless) * characterCount);
//        return acc;
//      }, [])
//      .join(" ");
//
//    const dy = lines
//      .reduce(
//        function(acc, line) {
//          const characterCount = line.length;
//          for (let i = 0; i < line.length; i++) {
//            acc.push(0);
//          }
//          acc.push(lineHeightPx);
//          return acc;
//        },
//        [-1 * (lines.length - 1) * lineHeightPx / 2]
//      )
//      .join(" ");
//
//    const totalTextWidth =
//      Math.max.apply(undefined, lines.map(line => line.length)) * fontSize / 2;
//    const tspanXMapper = {
//      rtl: {
//        start: -totalTextWidth,
//        middle: 0,
//        end: totalTextWidth
//      },
//      ltr: {
//        start: 0,
//        middle: 0,
//        end: 0
//      }
//    };
//    const tspanX = tspanXMapper[textDirection][textAnchor];
//
//{line.split("").map(character => `‎${character}`).join("")}
//{he.encode(line)}
//    return (
//      <text
//        dominantBaseline="central"
//        dx={dx}
//        dy={dy}
//        textLength="300"
//        fill={fill}
//        fontFamily={fontFamily}
//        fontSize={`${fontSize}px`}
//        fontStyle={fontStyle}
//        fontWeight={fontWeight}
//        textAnchor={textAnchor}
//        transform={transforms.join(" ")}
//      >
//        {lines.map(function(line, i) {
//          return (
//            <tspan
//              key={`text-line-${i}-${line}`}
//              textLength={line.length * fontSize / lineHeightUnitless}
//            >
//              {line}
//            </tspan>
//          );
//        })}
//        {/*
//        {textContent}
//        dx={dx}
//        {lines.map(function(line, i) {
//          //x={tspanX}
//          //dy={(i - (lineCount - 1) / 2) * lineHeightPx}
//          return (
//            <tspan
//              key={`text-line-${i}-${line}`}
//              x="0"
//              dy={
//                i === 0 ? -1 * (lineCount - 1) * lineHeightPx / 2 : lineHeightPx
//              }
//            >
//              {line}
//            </tspan>
//          );
//        })}
//					*/}
//      </text>
//    );
/*
function getTextPathXValues(padding, textDirection, width) {
  if (textDirection === "rtl") {
    return [width - padding, padding];
  } else {
    return [padding, width - padding];
  }
}
//*/
/* In case I ever want to render text on edges, here's a start
            const [x0, x1] = getTextPathXValues(
                padding,
                textDirection,
                width
            );
      const length = Math.floor(height / (lineHeightPx));
      const d = fill("", 0, length, Array(length))
        .map(function(p, i) {
          const y = (lineHeightPx) * (i + 1);
          return `M ${x0} ${y} L ${x1} ${y}`;
        })
        .join("\n");
      const pathId = `mypath-for-${id}`;
      return (
        <g>
          <path id={pathId} d={d} />
          <text
            textAnchor={textAnchor}
            dx={xTranslation}
            style={style}
            fill={fill}
            dominantBaseline="central"
          >
            <textPath xlinkHref={`#${pathId}`}>
              {textContent.replace(lineBreakRegex, "")}
            </textPath>
          </text>
        </g>
        //*/
//# sourceMappingURL=data:application/json;base64,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